<template>


      <VueCodeHighlight>
        <pre class="language-javascript">
<code>

  Node.js Digital asset connection
  
  TRANSACTION BREAKDOWN

  // First we assign our private key (You get your private key with your account intergration)
  const signatureProvider = new JsSignatureProvider([context.privKey]);

  // Define our API
  const api = new Api({ rpc, signatureProvider, textDecoder: new TextDecoder(), textEncoder: new TextEncoder() });

  // Make the transaction
  (async () => {
    const result = await api.transact({
      actions: [{
        account: '{{account}}', // Your account name (your smart contract)
        name: 'transfer', // the action name
        authorization: [{
          actor: paramss.sender, // The account name of the sender
          permission: 'active', // sign using active key
        }],
        data: {
          from: *sender_account_name*,
          to: *receiver_account_name*,
          quantity: `${(paramss.amount).toFixed(4)}  ${paramss.symbol}`, // amount to fixed decimals,
          memo: *memo*, // optional spot to write context or data to your transaction
        },
      }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30,
    });
    console.log(result);
  })();































</code>
<code>
  EXAMPLE TOKEN CREATION EVENT (premine) // This is the first action you perform

  (async () => {
    let resp = await api.transact({ actions: [{
      account: '{{account}}',
      name: 'create',
        authorization: [{
          actor: '{{account}}',
          permission: 'active',
        }],
        data: {
          issuer: {{account}},
          symbol: '*SYMBOL*', // example SYMBL, ABC, SPX - use this as a id for the asset 
        },
       }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30,
    });
  })












</code>
<code>
  EXAMPLE TOKEN ISSUANCE // this comes after you 'create'

  (async () => {
    const result = await api.transact({
      actions: [{
        account: '{{account}}',
        name: 'burn',
        authorization: [{
          actor: '{{account}}',
          permission: 'active',
        }],
        data: {
          to: '*receiver*',
          token_id: '"abc123"'
        },
      }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30,
    });
  })









</code>
<code>
  EXAMPLE TOKEN ISSUANCE // this comes after you 'create'

  (async () => {
    const result = await api.transact({
      actions: [{
        account: '{{account}}',
        name: 'issue',
        authorization: [{
          actor: '{{account}}',
          permission: 'active',
        }],
        data: {
          to: '*receiver*',
          quantity: `${(paramss.amount).toFixed(4)} ${paramss.symbol}`, // example 100000.0000 SYMBL
          uris: '*uri*',
          name: '*name*',
          memo: '*message*'
        },
      }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30,
    });
  })









</code>
<code>
  EXAMPLE TRANSACTION // after you have created a asset and issued it to an account

  (async () => {
    const result = await api.transact({
      actions: [{
        account: '{{account}}',
        name: 'transfer',
        authorization: [{
          actor: {{account}},
          permission: 'active',
        }],
        data: {
          from: 'smartpress11',
          to: paramss.receiver,
          quantity: `${(paramss.amount).toFixed(4)} ${paramss.symbol}`, // example 100000.0000 SYMBL
          memo: paramss.memo,
        },
      }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30,
    });
  })










</code>
<code>
  EXAMPLE TRANFER_ID // after you have created a asset and issued it to an account

  (async () => {
    const result = await api.transact({
      actions: [{
        account: '{{account}}',
        name: 'transfer_id',
        authorization: [{
          actor: 'smartpress11',
          permission: 'active',
        }],
        data: {
          from: '*sender*',
          to: '*receiver*',
          id: '*symbol*' // example SYMBL
          memo: paramss.memo,
        },
      }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30,
    });
  })
</code>
          </pre>
        </VueCodeHighlight>


      <!--                           END TOKEN NODE JS                       -->


  
</template>

<script>
  import store from "@/store"

  import { component as VueCodeHighlight } from 'vue-code-highlight';

  export default {
    data () {
      return {
        abc: '123',
        items: [
          { text: 'Actions' },
          { divider: true },
          { x: 100, text: 'Getting started' },
          { x: 2000, text: 'Create' },
          { x: 3050, text: 'Issue' },
          { x: 4050, text: 'Transfer' },
          { divider: true },
        ]
      }
    },
    components: {
      VueCodeHighlight
    },
    props: {
      keys: String,
      account: String
    },
    watch:  {
 
    
    },
    methods: {
      goto(x) {
        this.$vuetify.goTo(x)
      }
    },
    destroyed: function () {
    }
  }
</script>

<style>
  .test {
    color:red;
  }
</style>
